module.exports = __webpack_public_path__ + "static/media/check-box.73255501.svg";